import { getMarketingContextParams } from "@/lib/marketing-context";
import { GOOGLE_ANALYTICS_MEASUREMENT_ID } from "@/lib/tracking-constants";

type GoogleTagParams = Record<string, boolean | number | string | null>;

interface GoogleTag {
  (command: "consent", eventName: "default" | "update", params: GoogleTagParams): void;
  (command: "config", targetId: string, params: GoogleTagParams): void;
  (command: "event", eventName: string, params: GoogleTagParams): void;
}

declare global {
  interface Window {
    gtag?: GoogleTag;
  }
}

export function sendGoogleAdsConversion(sendTo: string): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: sendTo });
}

export function sendGoogleAnalyticsEvent(eventName: string, params: GoogleTagParams): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", eventName, {
    ...getMarketingContextParams(),
    ...params,
    send_to: GOOGLE_ANALYTICS_MEASUREMENT_ID,
  });
}

export function syncGoogleAnalyticsUser(userId: string | null): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("config", GOOGLE_ANALYTICS_MEASUREMENT_ID, {
    send_page_view: false,
    user_id: userId,
  });
}
